import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-autosuggest-input", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("autosuggest-input", "with-data-ingest"),
            componentTag: "ux-autosuggest-input",
            performActions: async (page) => {
                await page.click(".ux-autosuggest-input");
                await page.keyboard.type(String.fromCharCode(71));
            },
            pageHeight: 220,
            pageWidth: 500,
        });
    });
});
